import gql from 'graphql-tag';

export const CALENDAR_ACCOUNT_OPTIONS = gql`
  query CalendarAccountOptions {
    dealActivity {
      result: calendarAccountOptions {
        error
        success
        list {
          value
          label
        }
      }
    }
  }
`;
